import { useState, useEffect } from "react";
import { Container } from "@material-ui/core";
import { Typography, Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";

// Connectors
import backendConnector from "../../../services/connectors/backendConnector";

// Components
import AlertComponent from "../../elements/Alert";
import { DotFalling } from "../../loader/Loaders";
import HistoricalResult from "./HistoricalResult";
import CurrentAssessment from "./CurrentAssessment";
import AssessmentResultPopover from "./assessmentDashboard/AssessmentResultPopover";
import AssessmentDashboard from "./assessmentDashboard/AssessmentDashboard";

// Styles
import AssessmentResultsStyle from "../../../assets/styles/materialUI/questionnaire/assessmentResult/AssessmentResultsStyle";

// Providers
import { useLanguage } from "../../../contexts/languageContext";

export default function AssessmentResults() {
	const { t } = useTranslation();
	const { direction } = useLanguage();
	const classes = AssessmentResultsStyle();
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [message, setMessage] = useState(null);
	const [dataLoading, setDataLoading] = useState(false);
	const [currentAssessment, setCurrentAssessment] = useState({});
	const [historyResult, setHistoryResult] = useState([]);
	const [selectedAssessment, setSelectedAssessment] = useState(null);
	const [viewDialog, setViewDialog] = useState(false);
	const [openTooltip, setOpenTooltip] = useState(null);
	const [dashboardOpen, setDashboardOpen] = useState(false);
	const [submissionData, setSubmissionData] = useState([]);

	const getSubmissionData = async (item) => {
		setError(null);
		setDataLoading(true);
		let submission_data = {
			submission_id: item?.id,
		};
		let response = await backendConnector.getSubmissionData(submission_data);
		if (response?.data) {
			setSelectedAssessment(item);
			setSubmissionData(response?.data);
			setViewDialog(true);
		} else if (response?.error) {
			setError(response?.error);
		}
		setDataLoading(false);
		setTimeout(() => {
			setError(null);
		}, 3000);
	};

	const handleViewAnswers = async (item) => {
		await getSubmissionData(item);
	};

	useEffect(() => {
		initiateResult(true);
	}, []);

	const initiateResult = async (fullLoading = false) => {
		setError(null);
		setLoading(fullLoading);
		let response = await backendConnector.initiateResult();
		if (response?.currentAssessment) {
			setCurrentAssessment(response?.currentAssessment);
		}
		if (response?.historyResult) {
			setHistoryResult(response?.historyResult);
		}
		if (response?.error) {
			setError("assessment.results.historyInitError");
		}
		setLoading(false);
	};

	const handleCloseDialogs = () => {
		setViewDialog(false);
		setDashboardOpen(false);
		setOpenTooltip(false);
	};

	return (
		<>
			<Container
				className={dataLoading ? classes.inactiveMainContainer : classes.activeMainContainer}
				dir={direction}
			>
				<div className={classes.headerContainer}>
					<div className={classes.headerInner}>
						<Typography variant="h6" className={classes.headerMainText}>
							{t("assessment.results.header")}
						</Typography>
						<Typography variant="h6" className={classes.headerSubText}>
							{t("assessment.results.subHeader")}
						</Typography>
					</div>
				</div>
				{loading && (
					<Grid className={classes.loaderContainer}>
						<DotFalling />
					</Grid>
				)}

				{dataLoading && (
					<Grid className={classes.dataLoaderContainer}>
						<DotFalling className={classes.dataLoader} />
					</Grid>
				)}
				{!loading && (
					<div>
						<CurrentAssessment currentAssessment={currentAssessment} />
						<AssessmentDashboard
							selectedAssessment={selectedAssessment}
							dashboardOpen={dashboardOpen}
							submissionData={submissionData}
							handleCloseDialogs={handleCloseDialogs}
							openTooltip={openTooltip}
							setOpenTooltip={setOpenTooltip}
						/>
						<HistoricalResult
							setError={setError}
							setMessage={setMessage}
							setLoading={setLoading}
							historyResult={historyResult}
							handleViewAnswers={handleViewAnswers}
							setSubmissionData={setSubmissionData}
							setDataLoading={setDataLoading}
							setSelectedAssessment={setSelectedAssessment}
							selectedAssessment={selectedAssessment}
							viewDialog={viewDialog}
							handleCloseDialogs={handleCloseDialogs}
							submissionData={submissionData}
							initiateResult={initiateResult}
							setHistoryResult={setHistoryResult}
							setDashboardOpen={setDashboardOpen}
						/>
						<AssessmentResultPopover
							selectedAssessment={selectedAssessment}
							submissionData={submissionData}
							viewDialog={viewDialog}
							handleCloseDialogs={handleCloseDialogs}
						/>
					</div>
				)}
				{(error || message) && (
					<AlertComponent
						errors={error ? [error] : []}
						messages={message ? [message] : []}
						setError={setError}
						setMessage={setMessage}
					/>
				)}
				<Grid className={classes.footer} />
			</Container>
		</>
	);
}
